import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vant from 'vant';
import 'vant/lib/index.css';
import plugins from '@/utils/plugins';
import { Toast } from 'vant';
import { Dialog } from 'vant';
import { getMobileToken, wxConfig, wxlogin } from '@/api/base';
import { getParams } from '@/utils/index';
import MetaInfo from 'vue-meta-info';

import plateList from './utils/plateList';
window.localStorage.setItem('plateList', JSON.stringify(plateList));
Vue.use(MetaInfo);
Vue.use(plugins);
Vue.use(Vant);
Vue.use(Toast);
Vue.use(Dialog);
Vue.config.productionTip = false;
// common.css
import '@/assets/css/common.css';
import 'amfe-flexible'; //引入rem自适应
router.beforeEach((to, from, next) => {
  console.log(to, from);
  if (from.query.icoi) {
    to.query.icoi = from.query.icoi;
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // document.documentElement.scrollTop = 0;
  let openId = window.localStorage.getItem('openId') || to.query.openId;
  let sessionKey = window.localStorage.getItem('sessionKey') || to.query.sessionKey;

  // 标记是否需要清除URL参数（防止分享时泄露敏感信息）
  let shouldCleanParams = false;

  if (to.query.openId && to.query.nickName) {
    window.localStorage.setItem('userInfo', JSON.stringify(to.query));
  }
  if (to.query.openId) {
    window.localStorage.setItem('openId', to.query.openId);
    shouldCleanParams = true;
  }
  if (to.query.sessionKey) {
    window.localStorage.setItem('sessionKey', to.query.sessionKey);
    shouldCleanParams = true;
  }

  // 如果刚刚登录成功（URL中有openId或sessionKey），清除地址栏所有参数
  if (shouldCleanParams) {
    router.replace({ path: to.path, query: {} });
    return;
  }

  window.openId = openId;
  if (to.path == '/posts' || to.path == '/coin' || to.path == '/rtjQuote') {
    next();
  } else if (
    (!openId && to.path.indexOf('login') == '-1') ||
    (!sessionKey &&
      to.path.indexOf('login') == '-1' &&
      to.query.subscribe &&
      to.query.subscribe === 'true')
  ) {
    let href = encodeURIComponent(window.location.href);
    // next(`/login?backUrl=${href}`)
    wxlogin({ backUrl: href }).then(res => {
      window.location.href = res.data;
    });
  }
  // else if(to.query && to.query.subscribe && to.query.subscribe==="false"){
  //   Dialog.alert({
  //     message: '您尚未关注公众号,请先关注公众号！！！',
  //     confirmButtonText	:'去关注'
  //   }).then(() => {
  //     // on clos
  //     window.location.href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg3MTczOTQxMw==#wechat_redirect"
  //   });
  // }
  else {
    next();
  }
});
const u = navigator.userAgent;
const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
const el = isiOS ? document.documentElement : document.body;
// 页面滚动到指定位置
router.afterEach((to, from) => {
  console.log(to);
  console.log(from);
  // if (to.meta.keepAlive && to.meta.scrollHeight && from.path!='/plate') {
  //   setTimeout(() => {
  //     console.log(window)
  //     console.log(to.meta.scrollHeight)
  //     el.scrollTop = to.meta.scrollHeight
  //   }, 80)
  // } else {
  //   // Vue.nextTick(() => {
  //   //   el.scrollTop = 0
  //   // })
  // }
});
//  getMobileToken(getParams()).then(res=>{
// let token=res.token
// window.localStorage.setItem('extra_user_token',token)
// window.extra_user_token=res.token
wxConfig({ url: location.href }).then(res => {
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: res.data.appId, // 必填，公众号的唯一标识
    timestamp: res.data.timestamp, // 必填，生成签名的时间戳
    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
    signature: res.data.signature, // 必填，签名
    jsApiList: [
      'onMenuShareAppMessage',
      'onMenuShareTimeline',
      'chooseWXPay',
      'showOptionMenu',
      'updateAppMessageShareData',
      'updateTimelineShareData',
      'hideMenuItems',
      'showMenuItems',
      'chooseImage',
      'uploadImage',
    ], // 必填，需要使用的JS接口列表
    openTagList: ['wx-open-launch-weapp'],
  });

  wx.ready(function() {
    wx.updateAppMessageShareData({
      title: '一尘盯盘助手', // 分享标题
      desc: '一尘网查价、盯盘自动提醒，捡漏快人一步！', // 分享描述
      link: 'https://ui.smartrecorder.xyz/#/plate', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'https://ui.smartrecorder.xyz/image/ycIcon.jpg', // 分享图标
      success: function() {
        // 设置成功
      },
    });
    wx.updateTimelineShareData({
      title: '一尘盯盘助手', // 分享标题
      desc: '一尘网查价、盯盘自动提醒，捡漏快人一步！', // 分享描述
      link: 'https://ui.smartrecorder.xyz/#/plate', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'https://ui.smartrecorder.xyz/image/ycIcon.jpg', // 分享图标  //https://ycawxmp.oss-cn-beijing.aliyuncs.com/icon.jpg
      success: function() {
        // 设置成功
      },
    });
    wx.onMenuShareAppMessage({
      title: '一尘盯盘助手', // 分享标题
      desc: '一尘网查价、盯盘自动提醒，捡漏快人一步！', // 分享描述
      link: 'https://ui.smartrecorder.xyz/#/plate', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'http://ui.smartrecorder.xyz/image/ycIcon.jpg', // 分享图标
      success: function() {
        // 用户点击了分享后执行的回调函数
      },
    });
    wx.onMenuShareTimeline({
      title: '一尘盯盘助手', // 分享标题
      link: 'https://ui.smartrecorder.xyz/#/plate', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'http://ui.smartrecorder.xyz/image/ycIcon.jpg', // 分享图标
      success: function() {
        // 用户点击了分享后执行的回调函数
      },
    });
  });
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
});
// })
